import type { ILead } from 'api/types/lead';
import { Columns, HiddenColumns } from 'constants/columns';

/**
 * This function maps the table data against the table column accessors.
 *
 * @param data {ILead[]} - The data to be mapped and displayed in the table. In this phase, the table
 * expects only one data Interface to be used within the app. If needed, more "integrations" can be added.
 */
export const prepareData = (
    data: ILead[],
    displayedMarketValue: number | string,
    totalMarketValue?: number | string
) =>
    data.map((lead) => {
        return {
            [Columns.ID]: lead.propertyLeadId,
            [Columns.ADDRESS]: lead.address,
            [Columns.CITY]: lead.city,
            [Columns.STATE]: lead.state,
            [Columns.ZIP]: lead.zip,
            [Columns.EDM]: `${lead.edms?.length || 0} people`,
            [Columns.LEAD_TYPE]: lead.leadType,
            [Columns.DATE_ADDED]: lead.created,
            [Columns.MARKET_VALUE]: lead.estimatedMarketValue,
            [Columns.DISPLAYED_MARKET_VALUE]: displayedMarketValue,
            [Columns.TOTAL_MARKET_VALUE]: totalMarketValue,
            [HiddenColumns.OWNER1]: lead.owners,
            [HiddenColumns.OWNER2]: lead.owners,
            [HiddenColumns.OBIT_FIRST_NAME]: lead.obitFirstName,
            [HiddenColumns.OBIT_LAST_NAME]: lead.obitLastName,
            [HiddenColumns.EDMS]: lead.edms,
        };
    });
